
import { NotificationContainer } from 'react-notifications';
import styles from '../App.module.css';
import { isAuthenticated, permissionConfig } from '../index'

function Error() {

  async function handleSignin() {
    const {  userPermission } = isAuthenticated();
    const permission = userPermission || 0;
    const firstPath = permissionConfig[permission][0]; // Obter o primeiro path para redirecionar
    window.location.href = firstPath;
  }


  return (
    <div>
      <NotificationContainer />
      <div className={styles.container}>
        <div className={styles.label} style={{ padding: "20px" }}>
          {/* Exemplo: exibindo o GIF como se fosse uma imagem */}
          <img
            src="\memoji\No Way Penguin.gif"
            alt="Penguin GIF"
            style={{
              maxWidth: '200px',
              height: 'auto',
              display: 'block',
              margin: '20px auto',
              borderRadius: "20px"
            }}
          />
          <div>
          <h1>404 - Acesso Negado</h1>
          </div> 
          <p className={styles.pzinho} >Tente fazer <a href="/signin">login com outra conta</a> ou volte para a home.</p>
        </div>
        <div >
          <button className={styles.button} Text="Entrar" onClick={handleSignin}>voltar</button>

        </div>
      </div>
      <div className={styles.rodape}>
      </div>
    </div>
  );
};

export default Error;
